export const POWERAPPS_EXPIRATION_TIME_KEY = 'paExp';
export const POWERAPPS_INITIATED_KEY = 'paInit';
export const EXPERLOGIX_EXPIRATION_TIME_KEY = 'elExp';

export interface PowerAppsConnectProps {
  force?: boolean;
  globalLoader?: boolean;
}
